<template>
  <div>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column align="center" prop="circleId" label="圈子ID" width="80">
      </el-table-column>

      <!-- <el-table-column align="center" prop="name" label="圈子昵称" width="180" show-overflow-tooltip>
      </el-table-column> -->

      <el-table-column align="center" prop="userid" label="用户id" width="80">
      </el-table-column>

      <el-table-column align="center" label="用户昵称" prop="userName" width="130" show-overflow-tooltip>
      </el-table-column>

      <el-table-column align="center" label="用户头像" width="80">
        <template slot-scope="scope">
          <el-image :src="scope.row.userPicture" fit="fill" :preview-src-list="[scope.row.userPicture]"
            style="width: 40px; height: 40px; border-radius: 50%;">
          </el-image>
        </template>
      </el-table-column>

      <el-table-column align="center" prop="createTime" label="加入时间" width="160">
      </el-table-column>

      <el-table-column prop="joinMsg" align="center" label="申请内容" show-overflow-tooltip width="200">
        <template slot-scope="scope">
          <div v-html>
            {{ scope.row.joinMsg ? scope.row.joinMsg : '--' }}
          </div>
        </template>
      </el-table-column>

      <el-table-column label="申请状态" prop="joinStatus" align="center" width="80">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.joinStatus == 0 ? 'primary' : scope.row.joinStatus == 1 ? 'success' : scope.row.joinStatus == 2 ? 'danger' : 'danger'">
            {{ scope.row.joinStatus == 0 ? '待审核' : scope.row.joinStatus == 1 ? '已加入' : scope.row.joinStatus == 2 ? '已拒绝'
              : '已退出' }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column align="center" label="操作" width="110" fixed="right">
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row, '同意')" type="text" size="small">同意</el-button>
          <el-button @click="handleClick(scope.row, '拒绝')" type="text" size="small">拒绝</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: right;">
      <el-pagination @current-change="currenChange" :current-page="params.pageNum" layout="prev, pager, next"
        :total="total_pages">
      </el-pagination>
    </div>

    <el-dialog title="审核操作" :visible.sync="examineShow" append-to-body width="400px">
        <el-form :model="joinCirlceForm" :rules="rules" ref="joinCirlceForm" label-width="100px" class="demo-joinCirlceForm">
        <el-form-item label="请选择" prop="joinStatus">
          <el-select v-model="joinCirlceForm.joinStatus" placeholder="请选择是否通过">
            <el-option label="通过" :value="1"></el-option>
            <el-option label="拒绝" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="joinCirlceForm.joinStatus == 2" label="拒绝理由" prop="reviewResult">
          <el-input v-model="joinCirlceForm.reviewResult"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitSetadminFn('joinCirlceForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getExamineJoinListApi, setExamineJoin } from '@/api/circle'
export default {
  name: 'checkCircle',
  props: {
    circleId: {
      type: String,
      default: '',
      required: true
    }
  },
  data() {
    return {
      tableData: [],
      total_pages: 1,
      params: {
        circleId: '',
        pageSize: 10,
        pageNum: 1
      },
      joinCirlceForm: {
        circleId: '',
        userid: '',
        joinStatus: 1,
        reviewResult: ''
      },
      examineShow: false,
      rules: {
        joinStatus: [{ required: true, message: '请选择审核结果', trigger: 'blur' }],
        reviewResult: [{ required: true, message: '请输入拒绝理由', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.params.circleId = this.circleId
    this.getDataFn()
  },
  methods: {
    async getDataFn() {
      getExamineJoinListApi(this.params).then(res => {
        if (res.code == 200) {
          this.tableData = res.data.records
          this.total_pages = res.data.total
        } else {
          this.$message.error(res.msg ? res.msg : '获取数据失败, 请重试')
        }
      }).catch(err => {
        this.$message.error(err ? err : '获取数据失败, 请重试')
      })

    },
    async handleClick(row, val) {
      this.examineShow = true;
      this.joinCirlceForm = {
        circleId: row.circleId,
        userid: row.userid,
        joinStatus: val === '同意' ? 1 : 2,
        reviewResult: ''
      }
    },
    // 分页被单击
    async currenChange(pages) {
      this.params.pageNum = pages
      this.getDataFn()
    },
    submitSetadminFn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          setExamineJoin(this.joinCirlceForm).then(res => {
            if (res.code == 200) {
              this.$message.success(res.msg ? res.msg : '操作成功')
              this.examineShow = false;
              this.getDataFn()
            } else {
              this.$message.error(res.msg ? res.msg : '操作失败, 请重试')
            }
          }).catch(err => {
            this.$message.error(err ? err : '操作失败, 请重试')
          })
        } else {
          this.$message.error('请填写拒绝理由')
          return false
        }
      })
    }
  }
}
</script>

<style></style>
